module.exports = '1.5.1';



//////////////////
// WEBPACK FOOTER
// (webpack)-dev-server/~/sockjs-client/lib/version.js
// module id = 49
// module chunks = 0